/**
 * useTwinScenarios Hook
 *
 * Fetches aggregated scenario data from all enabled apps (Site DNA, Flux EV, Flux COLD)
 * for the Digital Twin simulation setup.
 */

import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '@vortx/shared-ui';
import { apiGet, handleApiResponse } from '../services/api';
// Note: Uses flux_phd API endpoint for twin scenario data

export function useTwinScenarios(projectId) {
    const { currentUser } = useAuth();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [fetchKey, setFetchKey] = useState(0);

    useEffect(() => {
        if (!projectId || !currentUser) {
            setLoading(false);
            return;
        }

        let cancelled = false;

        async function fetchScenarios() {
            setLoading(true);
            setError(null);
            try {
                const response = await apiGet(
                    `/api/flux_phd/twin/projects/${projectId}/scenarios`,
                    currentUser
                );
                const result = await handleApiResponse(response);
                if (!cancelled) {
                    setData(result);
                }
            } catch (err) {
                if (!cancelled) {
                    setError(err);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        fetchScenarios();
        return () => { cancelled = true; };
    }, [projectId, currentUser, fetchKey]);

    const refetch = useCallback(() => {
        setFetchKey(prev => prev + 1);
    }, []);

    return { data, loading, error, refetch };
}
